import * as Yup from 'yup'

export const initialValuesCustomerAlias = customer_alias => ({
    customer_alias: customer_alias || '',
})

export const validationSchemaCustomerAlias = Yup.object().shape({
    customer_alias: Yup.string().required('The asset name cannot be empty'),
})

export const initialValuesNotes = notes => ({
    notes: notes || '',
})

export const validationSchemaNotes = Yup.object().shape({
    notes: Yup.string(),
})
